// src/components/Login.jsx
import React, { useState } from "react";
import api from "../api/api";
import "../styles/Login.css";

const Login = ({ onLogin }) => {
  const [nombre, setNombre] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await api.post("/api/auth/login", { nombre, password });

      const { token } = res.data;

      if (!token) {
        setError("No se recibió token de autenticación");
        return;
      }

      // ✅ Guardar token para el resto del sistema
      localStorage.setItem("token", token);

      // ✅ Notificar al componente padre (App)
      if (typeof onLogin === "function") onLogin(token);
    } catch (err) {
      console.error("Error en login:", err);

      if (err?.response?.status === 401 || err?.response?.status === 403) {
        setError("Usuario o contraseña incorrectos");
      } else {
        setError("Error de conexión con el servidor");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="logo-container">
        <img
          src="https://floristeria2000.com/wp-content/uploads/2020/12/LOGOFF.webp"
          alt="Logo Floristería"
          className="logo-img"
        />
      </div>

      <div className="login-container">
        <h2>Iniciar Sesión</h2>

        <form onSubmit={handleSubmit} className="login-form">
          {error && <p className="error-message">{error}</p>}

          <div className="form-group">
            <label htmlFor="nombre">Nombre de Usuario:</label>
            <input
              type="text"
              id="nombre"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Contraseña:</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" disabled={loading}>
            {loading ? "Ingresando..." : "Entrar"}
          </button>
        </form>
      </div>

      <footer className="login-footer">
        <small>Todos los derechos reservados - Floristería 2000</small>
      </footer>
    </div>
  );
};

export default Login;
